.thirdPartyContactAttributeGroup {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.thirdPartyContactAttribute {
    width: 30%;
    word-wrap: break-word;
}

.thirdPartyContactAttributeEmail {
    width: 40%;
    word-wrap: break-word;
}

